import { storeToRefs } from 'pinia';
import { shippingAddressTypeStore } from '~/stores/shippingAddressType';

import { ShippingAddressType } from '~~/types/checkout/ShippingAddressType';
import { shippingAddressTypeCookie } from '~~/constants/cookies';

const isShippingAddressType = (value: unknown): value is ShippingAddressType => {

  return Object.values(ShippingAddressType).includes(value as ShippingAddressType);

};

export default function () {

  const store = shippingAddressTypeStore();
  const { shippingAddressType } = storeToRefs(store);
  const { $cookies } = useNuxtApp();

  const shippingAddressCookie = $cookies.get(shippingAddressTypeCookie);

  store.setShippingAddressType(
    isShippingAddressType(shippingAddressCookie) ? shippingAddressCookie : ShippingAddressType.SAME_AS_BILLING,
  );

  const setShippingAddressTypeMutation = (shippingAddressType: ValueOf<typeof ShippingAddressType>) => {

    store.setShippingAddressType(shippingAddressType);
  
  };

  return {
    ...store,
    shippingAddressType,

    setShippingAddressTypeMutation,
  };

}